<template>
  <div class="theater-manage">
    <el-card>
      <div slot="header">
        <span>剧场名称管理</span>
        <el-button v-if="isSuperAdmin" type="primary" size="small" style="float:right" @click="openAdd">新增剧场</el-button>
      </div>

      <el-table :data="list" border stripe v-loading="loading">
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column prop="name" label="剧场名称" min-width="200"></el-table-column>
        <el-table-column label="创建时间" width="180">
          <template slot-scope="scope">{{ (scope.row.createTime || '').replace('T', ' ') }}</template>
        </el-table-column>
        <el-table-column v-if="isSuperAdmin" label="操作" width="140">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openEdit(scope.row)">编辑</el-button>
            <el-button type="text" size="small" style="color:#f56c6c" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog :title="editingId ? '编辑剧场' : '新增剧场'" :visible.sync="showDialog" width="400px">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="剧场名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入剧场名称"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showDialog = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
export default {
  name: 'TheaterManage',
  computed: {
    ...mapGetters(['isSuperAdmin'])
  },
  data() {
    return {
      list: [],
      loading: false,
      showDialog: false,
      editingId: null,
      form: { name: '' },
      rules: {
        name: [{ required: true, message: '请输入剧场名称', trigger: 'blur' }]
      }
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.loading = true
      api.theaterList().then(res => { this.list = res.data || [] }).finally(() => { this.loading = false })
    },
    openAdd() {
      this.editingId = null
      this.form = { name: '' }
      this.showDialog = true
    },
    openEdit(row) {
      this.editingId = row.id
      this.form = { name: row.name }
      this.showDialog = true
    },
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        if (this.editingId) {
          api.theaterUpdate({ id: this.editingId, name: this.form.name }).then(() => {
            this.$message.success('修改成功')
            this.showDialog = false
            this.loadData()
          })
        } else {
          api.theaterAdd({ name: this.form.name }).then(() => {
            this.$message.success('新增成功')
            this.showDialog = false
            this.loadData()
          })
        }
      })
    },
    handleDelete(row) {
      this.$confirm('确认删除 "' + row.name + '" ?', '提示', { type: 'warning' }).then(() => {
        api.theaterDelete(row.id).then(() => {
          this.$message.success('删除成功')
          this.loadData()
        })
      }).catch(() => {})
    }
  }
}
</script>
